<template>
  <div class="edit-time" v-if="editData">
    <div class="top">
      <div class="top-left">
        <div class="bj-name">{{ editData.p_title }}</div>
        <div class="bj-info"
          >{{ editData.every_times_num }}{{ editData.min_unit_txt }}/次</div
        >
      </div>
      <div class="cancel" @click="bindCancel">取消</div>
    </div>
    <div class="time-container">
      <van-datetime-picker
        v-model="currentTime"
        :show-toolbar="false"
        type="time"
        title="选择时间"
        @change="bindChange"
        item-height="55"
        visible-item-count="4"
        :filter="filterPickerTime"
      />
      <div class="time-text">
        <div class="hours">时</div>
        <div class="minute">分</div>
      </div>
    </div>
    <div class="save-btn" @click="bindSave">保存时间</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => ['00', '00']
    },
    editData: {
      type: Object,
      default: null
    }
  },
  components: {},

  data() {
    return {
      currentTime: '',
      _timeValues: ['00', '00']
    }
  },
  watch: {
    data() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    filterPickerTime(type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 10 === 0)
      }
      return options
    },
    init() {
      this.currentTime = this.data[0] + ':' + this.data[1]
      this._timeValues = this.data.map((item) => {
        return item
      })
    },
    bindChange(picker) {
      this._timeValues = picker.getValues()
    },
    bindCancel() {
      this.$emit('cancel')
    },
    bindSave() {
      this.$emit('save', this._timeValues)
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-time {
  @include paddingBottom(6px);
  .time-container {
    ::v-deep .van-picker-column__item {
      font-size: 24px;
      font-family: DINPro, DIN;
    }
    ::v-deep .van-picker-column__item--selected {
      font-size: 36px;
      font-family: DINPro, DIN;
    }
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px;

    .top-left {
      .bj-name {
        max-width: 290px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
      }

      .bj-info {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
      }
    }

    .cancel {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.7);
      line-height: 20px;
    }
  }

  .time-container {
    position: relative;

    .time-text {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      line-height: 22px;

      .hours {
        position: absolute;
        left: 38%;
        top: 51%;
        transform: translate(-50%, -50%);
      }

      .minute {
        position: absolute;
        left: 88%;
        top: 51%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .save-btn {
    margin: 10px 20px 0px;
    height: 48px;
    background: #03d4e6;
    border-radius: 24px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
  }
}
</style>
